import { Button, InputAdornment, MenuItem, Select, Stack, SvgIcon, TextField } from '@mui/material';
import { TextFieldProps } from '@mui/material/TextField/TextField';
import { Box } from '@mui/system';
import clsx from 'clsx';
import { ComponentType, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Roles } from 'src/enums/roles.enum';
import { Icons } from '../../icons';
import useStyles from './styles';

interface DataTableFilterProps {
  className?: string;
  value?: string | undefined | null;
  onUpdate: (x: Record<string, any>) => void;
  SearchFieldProps?: TextFieldProps;
}

export const DataTableFilter: ComponentType<DataTableFilterProps> = ({
  className,
  value: queryValue = '',
  onUpdate,
  SearchFieldProps = {},
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [value, setValue] = useState<string | undefined | null>('');

  const location = useLocation();

  const [role, setRole] = useState<string>('APPLICANT');

  const handleSubmit = (e: any) => {
    e.preventDefault();
    onUpdate({ search: value, role });
  };

  useEffect(() => {
    setValue(queryValue);
  }, [queryValue]);

  return (
    <form
      onSubmit={handleSubmit}
      action={'/'}
      method="GET"
      className={clsx(classes.root, className)}
    >
      <Stack direction="row" spacing={3}>
        {location.pathname === '/cabinet/users' ? (
          <Select
            label={t('action.search', 'Поиск')}
            required
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={role}
            onChange={(e) => {
              setRole(e.target.value);
            }}
          >
            {Object.entries(Roles).map((r) => (
              <MenuItem value={r[0]} key={r[0]}>
                {t('role.' + r[0])}
              </MenuItem>
            ))}
          </Select>
        ) : null}
        <TextField
          label={t('action.search', 'Поиск')}
          placeholder={t('action.search', 'Поиск')}
          value={value}
          onChange={(e: any) => setValue(e.target.value)}
          size="small"
          sx={{ width: 350 }}
          {...SearchFieldProps}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SvgIcon component={Icons.Search} viewBox="0 0 24 24" color="primary" />
              </InputAdornment>
            ),
          }}
        />
        <Box style={{ paddingTop: 21 }}>
          <Button type="submit" variant="contained" color="secondary">
            {t('action.search', 'Найти')}
          </Button>
        </Box>
      </Stack>
    </form>
  );
};
